
import { Vue } from 'vue-property-decorator';
import { readPrefixSiteUrl } from '@/store/main/getters';

export default class VueBase extends Vue {
  get prefixSiteUrl() {
    return readPrefixSiteUrl(this.$store);
  }
}
